import i18n from 'i18next';
import { number, object, string } from 'yup';
import { emailRegExp, phoneRegExp } from 'globalutils/constants';
import { checkServiceProvider } from './serviceProviderConfig';

export const getSchema = ({ type }) =>
  object().shape({
    company: string()
      .required(i18n.t('common.fieldRequiredMessage'))
      .test('len', i18n.t('Please enter atleast 4 characters.'), (val) => val && val.length > 3)
      .test('len', i18n.t('Please enter no more than 120 characters.'), (val) => val && val.length < 121),
    dotNumber: number().typeError('Please use numbers with maximum length 9').required(i18n.t('common.fieldRequiredMessage')),
    address: string().required(i18n.t('common.fieldRequiredMessage')),
    city: string().required(i18n.t('common.fieldRequiredMessage')),
    state: string().required(i18n.t('common.fieldRequiredMessage')),
    radiusTolerance: number()
      .typeError('Please use numbers')
      .test(
        'is-decimal',
        i18n.t('Please enter only 2 digits after decimal point'),
        (value) => !(value + '').includes('.') || (value + '').match(/^\d*\.{1}\d{0,2}$/)
      ),
    insuranceExpDate: string().required(i18n.t('common.fieldRequiredMessage')),
    freeTrialEndDate: string().when('autoPaymentEnabled', {
      is: false, // Only required when autoPaymentEnabled is false
      then: string().nullable().required(i18n.t('common.fieldRequiredMessage')),
      otherwise: string().notRequired(),
    }),
    ...(type === 'edit'
      ? {
          zipCode: string().required(i18n.t('common.fieldRequiredMessage')),
          companyPhone: string().required(i18n.t('common.fieldRequiredMessage')),
          ...checkServiceProvider('schema_edit', window?.$environment?.SERVICE_PROVIDER, false),
        }
      : {
          firstName: string()
            .test('len', i18n.t('common.atleast2Chars'), (val) => val && val.length > 1)
            .required(i18n.t('common.fieldRequiredMessage')),
          lastName: string()
            .test('len', i18n.t('common.atleast2Chars'), (val) => val && val.length > 1)
            .required(i18n.t('common.fieldRequiredMessage')),
          userPhone: string()
            .matches(phoneRegExp, i18n.t('common.validNumFormat'))
            .required(i18n.t('common.fieldRequiredMessage')),
          email: string()
            .matches(emailRegExp, i18n.t('common.emailValidationMessage'))
            .required(i18n.t('common.fieldRequiredMessage')),
          password: string().required(i18n.t('common.fieldRequiredMessage')),
          initialTrucks: number()
            .nullable()
            .min(0, 'Must be greater than zero')
            .max(10000, i18n.t('common.validName10000'))
            .integer('Count should not be a decimal number.')
            .required(i18n.t('common.fieldRequiredMessage')),
        }),
    underwriterId: string().required(i18n.t('common.fieldRequiredMessage')),
    lossControlId: string().required(i18n.t('common.fieldRequiredMessage')),
  });
